import React from "react";
import { Card, CardCounter } from "./index.styled";
import { TextContainer } from "../../pages/landing/index.styled";

const CardItem = ({ cardItem }) => {
  const { id, icon, color, title, content } = cardItem;
  const e2p = (s) => s.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  return (
    <Card key={id} color={color}>
      <div>
        <img src={icon} alt={title} />
      </div>
      <div>
        <h3>{title}</h3>
      </div>
      <TextContainer width="100%">
        <p>{content}</p>
      </TextContainer>
      <CardCounter color={color}>
        <p>{e2p(String(id))}</p>
      </CardCounter>
    </Card>
  );
};

export default CardItem;
